const guide = {
    start_building: 'شروع به ساخت',
    get_started: 'شروع کنید',
    categories: {
        featured: 'محبوب و برای شما',
        Traditional: 'برنامه وب سنتی',
        SPA: 'برنامه تک‌صفحه‌ای',
        Native: 'بومی',
        MachineToMachine: 'ماشین به ماشین',
        Protected: 'یکپارچه‌سازی بدون SDK',
        ThirdParty: 'برنامه شخص ثالث',
        SAML: 'برنامه SAML',
    },
    filter: {
        title: 'فیلتر فریم‌ورک',
        placeholder: 'جستجو برای فریم‌ورک',
    },
    checkout_tutorial: 'آموزش {{name}} را ببینید',
    do_not_need_tutorial: 'اگر به آموزش نیاز ندارید، می‌توانید بدون راهنمای فریم‌ورک ادامه دهید',
    finish_and_done: 'پایان و اتمام',
    cannot_find_guide: 'راهنمای خود را پیدا نمی‌کنید؟',
    describe_guide_looking_for: 'راهنمایی که به دنبال آن هستید را توصیف کنید',
    request_guide_successfully: 'درخواست شما با موفقیت ثبت شد. متشکریم!',
    app: {
        select_framework_or_tutorial: 'یک فریم‌ورک یا آموزش انتخاب کنید',
        guide_modal_title: 'شروع با SDK و راهنماها',
        modal_subtitle: 'فرآیند توسعه برنامه خود را با SDK و آموزش‌های از پیش ساخته شده ما سرعت ببخشید.',
        select_a_framework: 'یک فریم‌ورک انتخاب کنید',
        continue_without_framework: 'ایجاد برنامه بدون فریم‌ورک',
        describe_guide_looking_for_placeholder: 'مثلاً، می‌خواهم Logto را در برنامه Angular خود یکپارچه کنم.',
    },
    api: {
        modal_title: 'شروع با آموزش‌ها',
        modal_subtitle: 'فرآیند توسعه برنامه خود را با آموزش‌های از پیش ساخته شده ما سرعت ببخشید.',
        select_a_tutorial: 'یک آموزش انتخاب کنید',
        continue_without_tutorial: 'ادامه بدون آموزش',
        describe_guide_looking_for_placeholder: 'مثلاً، می‌خواهم API خود را با استفاده از deno محافظت کنم.',
    },
};
export default Object.freeze(guide);
